import { API_ORIGIN, authorizedFetch } from '@yeshuman/sdk'
import { useQuery } from '@tanstack/react-query'

export type ApplicationCoverLetter = {
  cover_letter: string
  submitted_at: string
}

async function fetchApplicationCoverLetter(applicationId: string): Promise<ApplicationCoverLetter> {
  const response = await authorizedFetch(
    `${API_ORIGIN}/api/applications/${encodeURIComponent(applicationId)}/cover-letter/`,
  )
  if (!response.ok) {
    throw new Error(`Failed to load cover letter (${response.status})`)
  }
  return response.json()
}

export function useApplicationCoverLetter(applicationId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['application-cover-letter', applicationId],
    queryFn: () => fetchApplicationCoverLetter(applicationId!),
    enabled: enabled && !!applicationId,
  })
}
